import {
  FaCheckCircle,
  FaCheck,
  FaIdCard,
  FaMapMarkerAlt,
  FaPlusSquare,
  FaFileAlt,
  FaFile,
  FaWhatsapp,
  FaEnvelope,
  FaPhone,
} from "react-icons/fa";
import { FaDownload } from "react-icons/fa6";
import Swal from "sweetalert2";

const SubscriptionCard = ({ subscriptionData, onUnsubscribe }) => {
  const isActive = subscriptionData.subscriptionStatus === "ACTIVE";

  return (
    <div className=" pb-6 font-sans">
      {/* Banner */}
      {/* <img
        src="/active.png"
        alt="Active"
        className="object-cover h-full w-full"
      /> */}
      <div className="bg-white text-center pt-8 pb-4">
        {/* Banner Image */}
        <img
          src="/active.png"
          alt="Active"
          className="w-full max-w-65 mx-auto object-contain"
          loading="lazy"
        />

        {/* Content */}
        <div className="px-6 -mt-14">
          <h2 className="text-xl font-bold">You’re Covered</h2>

          <p className="text-sm text-gray-600">
            Your travel insurance is now{" "}
            <span className="font-semibold">active</span>
          </p>

          <p className="text-xs text-gray-500 mt-2">
            Your policy has been issued successfully. <br />
            Documents are ready and shared with you.
          </p>
        </div>
      </div>
      {/* <div
        className="relative w-full h-64 md:h-100 flex flex-col items-center justify-end text-center bg-no-repeat bg-top bg-cover"
        style={{ backgroundImage: "url('/active.png')" }}
      >
      
        <div className="absolute -bottom-10">
          <h2 className="text-xl font-bold">You’re Covered</h2>

          <p className="text-sm text-gray-600">
            Your travel insurance is now{" "}
            <span className="font-semibold">active</span>
          </p>

          <p className="text-xs text-gray-500 mt-2">
            Your policy has been issued successfully. <br />
            Documents are ready and shared with you.
          </p>
        </div>
   
      </div> */}

      {/* Floating Card */}
      <div className=" px-4">
        <div className="bg-white rounded-2xl shadow-xl outline outline-gray-200 p-4 flex justify-between items-center">
          <div>
            <h5 className="font-semibold">{subscriptionData.planName}</h5>
            <p className="text-sm text-gray-500">
              {subscriptionData.coverageTypeLabel}
            </p>
            <p className="text-sm text-gray-500">
              {subscriptionData.tripDurationLabel}
            </p>
          </div>

          <div className="bg-yellow-400 px-3 py-2 rounded-lg text-center shadow">
            <strong className="block">
              PKR {subscriptionData.finalPremiumPKR}
            </strong>
            <span className="text-xs">Paid ✓</span>
          </div>
        </div>
      </div>

      {/* Info Grid */}
      <div className="grid grid-cols-2 gap-3 px-4 mt-4">
        {/* <div className="bg-white rounded-xl shadow p-3 flex flex-col items-center justify-center ">
          <p className="text-sm text-gray-800 font-bold">Policy No.</p>
          <div className="flex items-center justify-center w-full gap-2 ">
            <FaIdCard className="text-yellow-500" />
            <span className="text-sm font-semibold">54893217</span>
          </div>
        </div> */}

        <div className="bg-white rounded-xl shadow p-3 flex flex-col items-center justify-center ">
          <p className="text-sm text-gray-800 font-bold">Destination</p>
          <div className="flex items-center justify-center w-full gap-2 ">
            <FaMapMarkerAlt className="text-yellow-500 h-6 w-6" />
            <span className="text-xs font-semibold">
              {subscriptionData.coverageZoneLabel}
            </span>
          </div>
        </div>

        <div className="bg-white rounded-xl shadow p-3 flex flex-col items-center justify-center ">
          <p className="text-sm text-gray-800 font-bold">Medical Cover</p>
          <div className="flex items-center justify-center w-full gap-2 ">
            <FaPlusSquare className="text-yellow-500" />
            <span className="text-sm font-semibold">
              {subscriptionData.medicalCoverageLimit}
            </span>
          </div>
        </div>

        <div className="bg-white rounded-xl shadow p-3 flex flex-col items-center justify-center ">
          <p className="text-sm text-gray-800 font-bold">Status</p>
          <div className="flex items-center justify-center w-full gap-2 ">
            <FaCheckCircle className="text-green-500 h-6 w-6" />

            <span className="text-sm font-semibold text-green-600">Active</span>
          </div>
          {/* <p className="text-xs text-center pt-2 font-semibold">
            Expire at: {new Date(subscriptionData.expiresAt).toDateString()}
          </p> */}
        </div>
      </div>

      {/* Documents Box */}
      <div className="px-4 mt-4">
        <div className="bg-yellow-50 border border-yellow-100 rounded-xl p-4 flex gap-3 shadow-sm">
          <FaFileAlt className="text-yellow-500 text-xl" />
          <div>
            <p className="font-semibold text-sm">Your documents are ready</p>
            <p className="text-xs text-gray-500">
              Download your policy certificate & wording. Also sent via Email &
              WhatsApp.
            </p>
          </div>
        </div>
      </div>

      {/* Buttons */}
      <div className="px-4 mt-4 space-y-2!">
        <button
          onClick={() =>
            window.open(
              `https://policy.digiinsurance.com.pk/policies/view/${subscriptionData?.digiUserId}/${subscriptionData?.digiSubId}`,
              "_blank",
            )
          }
          className="w-full flex  items-center justify-center gap-2 py-3 rounded-xl! bg-linear-to-r from-black to-gray-800 text-white shadow-lg"
        >
          <FaDownload /> Download Policy Certificate
        </button>

        <button
          onClick={() =>
            window.open(
              "https://wa.me/9242111000420?text=Hi%20I%20want%20my%20policy%20details",
              "_blank",
            )
          }
          className="w-full py-3 rounded-xl! bg-linear-to-r from-amber-200 to-amber-300 text-black flex justify-center items-center gap-2"
        >
          <FaWhatsapp className="text-green-700 h-6 w-6" />
          Share on WhatsApp
        </button>
      </div>

      {/* Extra Actions */}
      <div className="flex justify-between px-6 mt-4 text-center text-xs">
        {/* Email */}
        <div
          onClick={() => {
            // Copy email to clipboard
            navigator.clipboard
              .writeText("support@digiinsurance.com.pk")
              .then(() => {
                Swal.fire("Email address copied to clipboard!");
              })
              .catch((error) => {
                console.error("Failed to copy email address: ", error);
              });
          }}
          className="bg-white rounded-xl shadow p-3 flex flex-col items-center cursor-pointer hover:shadow-md"
        >
          <FaEnvelope className="text-lg mb-1" />
          <span>Email</span>
        </div>

        {/* View Benefits */}
        <div
          onClick={() =>
            window.open(
              "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
              "_blank",
            )
          }
          className="bg-white rounded-xl shadow p-3 flex flex-col items-center cursor-pointer hover:shadow-md"
        >
          <FaFile className="text-lg mb-1" />
          <span>View Benefits</span>
        </div>

        {/* Emergency Help */}
        <div
          onClick={() => window.open("tel:+9242111000420")}
          className="bg-white rounded-xl shadow p-3 flex flex-col items-center cursor-pointer hover:shadow-md"
        >
          <FaPhone className="text-lg mb-1" />
          <span>Emergency Help</span>
        </div>
      </div>

      {/* Tips Box */}
      <div className="px-4 mt-5">
        <div className="border border-dashed border-yellow-300 rounded-xl p-4 text-xs text-gray-600 bg-yellow-50">
          <p className="font-semibold mb-2">Before you travel:</p>
          <ul className="list-disc ml-4 space-y-1">
            <li>Save your policy offline</li>
            <li>Review benefits & exclusions</li>
            <li>Keep emergency number handy</li>
          </ul>
        </div>
      </div>

      {/* Dashboard Button */}
      {/* <div className="px-6 mt-5">
        <button
          onClick={onUnsubscribe}
          className="w-full py-3 rounded-full bg-linear-to-r from-yellow-400 to-yellow-500 font-semibold shadow-lg"
        >
          Unsubscribe
        </button>
      </div> */}
    </div>
  );
};

export default SubscriptionCard;
